// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__19cLV","contentFooter":"Panel_contentFooter__1P9jf","artistLink":"Panel_artistLink__18MF0","artistLinkContent":"Panel_artistLinkContent__3g_Hv"};